import gql from 'graphql-tag';

export const listShipmentConfigurations = gql `
  query listShipmentConfigurations {
    listShipmentConfigurations {
      carriers {
          id
          label
          value
      }
      programTypes {
          id
          label
          value
      }
      orderTypes {
          id
          label
          value
          applicableForBookingOrAsn
          description
      }
      reasonCodes {
          id
          label
          value
          metadata {
              state
              category
          }
      }
    }
  }
`;